"use client";

const HISTORY_KEY = "pro-his";

let recentViews: {
  views: string[];
} = {
  views: [],
};

export function getRecent() {
  return recentViews.views;
}

export function init() {
  const list = localStorage.getItem(HISTORY_KEY);
  if (list) {
    const array = JSON.parse(list);
    if (Array.isArray(array)) {
      recentViews.views = array;
    }
  }
}

export function addProduct(id: string) {
  const newList = [id];

  for (const item of recentViews.views) {
    if (item !== id) {
      newList.push(item);
    }
  }

  recentViews.views = newList;

  localStorage.setItem(HISTORY_KEY, JSON.stringify(newList));
}
